import axios from 'axios';
import * as constants from '../../constants/constants';
import { toastError, toastSuccess } from '../../utils/toastMessage';
import API from '../../utils/API';
import { DEFAULT_TYPE_OF_VIDEOS_FOR_REQUEST } from '../../constants/appConstants';

export const setTrainingVideosList = (trainingVideosList) => {
  return {
    type: constants.SET_TRAINING_VIDEOS_LIST,
    payload: {
      trainingVideosList: trainingVideosList,
    },
  };
};

export const setTemplateVideo = (templateVideo) => {
  return {
    type: constants.SET_TEMPLATE_VIDEO,
    payload: {
      templateVideo: templateVideo,
    },
  };
};

export const setActiveVideo = (activeVideo) => {
  return {
    type: constants.SET_ACTIVE_VIDEO,
    payload: {
      activeVideo: activeVideo,
    },
  };
};

export const setIsVideoModalOpen = (isOpen) => {
  return {
    type: constants.SET_IS_VIDEO_MODAL_OPEN,
    payload: {
      isVideoModalOpen: isOpen,
    },
  };
};

export const setTrainingVideo = (trainingVideo) => {
  return {
    type: constants.SET_TRAINING_VIDEO,
    payload: {
      trainingVideo: trainingVideo,
    },
  };
};

export const setLimberingUpVideo = (limberingUpVideosList) => {
  return {
    type: constants.SET_LIMBERING_UP_VIDEOS_LIST,
    payload: {
      limberingUpVideosList: limberingUpVideosList,
    },
  };
};
export const setInterruptionVideo = (interruptionVideosList) => {
  return {
    type: constants.SET_INTERRUPTION_VIDEOS_LIST,
    payload: {
      interruptionVideosList: interruptionVideosList,
    },
  };
};
export const setSelfDevelopmentVideo = (selfDevelopmentVideosList) => {
  return {
    type: constants.SET_SELF_DEVELOPMENT_VIDEOS_LIST,
    payload: {
      selfDevelopmentVideosList: selfDevelopmentVideosList,
    },
  };
};
export const setMotivationVideo = (motivationVideosList) => {
  return {
    type: constants.SET_MOTIVATION_VIDEOS_LIST,
    payload: {
      motivationVideosList: motivationVideosList,
    },
  };
};
export const setWelcomeVideo = (welcomeVideosList) => {
  return {
    type: constants.SET_WELCOME_VIDEOS_LIST,
    payload: {
      welcomeVideosList: welcomeVideosList,
    },
  };
};
export const setFaqVideo = (faqVideosList) => {
  return {
    type: constants.SET_FAQ_VIDEOS_LIST,
    payload: {
      faqVideosList: faqVideosList,
    },
  };
};

export const setTemplateTrainingVideos = (templateTrainingVideosList) => {
  return {
    type: constants.SET_TEMPLATE_TRAINING_VIDEOS,
    payload: {
      templateTrainingVideosList: templateTrainingVideosList,
    },
  };
};

export const setSubtemplateTrainingVideos = (trainingsSubtemplateList) => {
  return {
    type: constants.SET_SUBTEMPLATE_TRAINING_VIDEOS,
    payload: {
      trainingsSubtemplateList: trainingsSubtemplateList,
    },
  };
};

export const setSubtemplateVideo = (subtemplateVideo) => {
  return {
    type: constants.SET_SUBTEMPLATE_VIDEO,
    payload: {
      subtemplateVideo: subtemplateVideo,
    },
  };
};
export const isCreateVideoLoading = () => {
  return {
    type: constants.IS_CREATE_VIDEO_LOADING,
  };
};
export const isCreateVideoEndLoading = () => {
  return {
    type: constants.IS_CREATE_VIDEO_END_LOADING,
  };
};

export const createTemplateVideo = (template) => {
  return () => {
    API.post(`admin/exercises/preset`, template)
      .then(() => {
        toastSuccess('Шаблон успешно создан');
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          toastError('Ошибка. Шаблон с таким именем уже существует');
        } else toastError('Ошибка создания шаблона');
      });
  };
};

export const changeTemplateVideo = (video) => {
  return () => {
    API.put(`admin/exercises/preset/${video.id}`, video)
      .then(() => {
        toastSuccess('Шаблон успешно обновлен');
      })
      .catch(() => {
        toastError('Ошибка обновления шаблона');
      });
  };
};

export const createSubtemplateVideo = (video) => {
  return () => {
    API.post(`admin/exercises/subpattern`, video)
      .then(() => {
        toastSuccess('Подшаблон успешно создан');
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          toastError('Ошибка. Подшаблон с таким именем уже существует');
        } else toastError('Ошибка создания подшаблона');
      });
  };
};

export const changeSubtemplateVideo = (video) => {
  return () => {
    API.put(`admin/exercises/subpattern/${video.id}`, {
      videos: video.videos,
      name: video.name,
      id: video.id,
    })
      .then(() => {
        toastSuccess('Подшаблон успешно обновлен');
      })
      .catch(() => {
        toastError('Ошибка обновления подшаблона');
      });
  };
};

export const createVideo = (video) => {
  return (dispatch) => {
    dispatch(isCreateVideoLoading());
    video.tags = video.tags.join('|');
    const fd = new FormData();
    Object.keys(video).map((fieldName) => {
      return fd.set(fieldName, video[fieldName]);
    });

    let actualLink = `https://cdn.${process.env.REACT_APP_API_URL.slice(8)}`;
    if (process.env.REACT_APP_API_URL === 'http://127.0.0.1:8000/')
      actualLink = 'http://cdn.127.0.0.1:8000/';
    const API_CDN = axios.create({
      baseURL: actualLink,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    });

    API_CDN.post(`/admin/exercises/video`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Basic YWRtaW46M3d6OEhxS0ZwYw==',
      },
    })
      .then(() => {
        dispatch(isCreateVideoEndLoading());
        toastSuccess('Видео успешно создано');
      })
      .catch((error) => {
        dispatch(isCreateVideoEndLoading());
        if (error.response && error.response.status === 422) {
          toastError('Ошибка. Видео с таким именем уже существует');
        } else toastError('Ошибка создания видео');
      });
  };
};

export const changeVideo = (video) => {
  return () => {
    video.tags = video.tags.join('|');
    const videosValue = {
      video_type: video.video_type,
      url: video.url,
      name: video.name,
      tags: video.tags,
      id: video.id,
    };
    const fd = new FormData();
    Object.keys(videosValue).map((fieldName) => {
      return fd.set(fieldName, video[fieldName]);
    });
    fd.append('_method', 'put');
    let actualLink = `https://cdn.${process.env.REACT_APP_API_URL.slice(8)}`;
    if (process.env.REACT_APP_API_URL === 'http://127.0.0.1:8000/')
      actualLink = 'http://cdn.127.0.0.1:8000/';
    const API_CDN = axios.create({
      baseURL: actualLink,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    });
    API_CDN.post(`admin/exercises/video/${video.id}`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Basic YWRtaW46M3d6OEhxS0ZwYw==',
      },
    })
      .then(() => {
        toastSuccess('Видео успешно обновлено');
      })
      .catch(() => {
        toastError('Ошибка обновления видео');
      });
  };
};

export const setChoosedVideosTags = (tags) => {
  return {
    type: constants.SET_CHOOSED_VIDEOS_TAGS,
    payload: {
      tags,
    },
  };
};

export const setSubtemplateTrainingVideosPageCount = (pageCount) => {
  return {
    type: constants.SET_SUBTEMPLATE_TRAINING_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setSubtemplateTrainingVideosCurrentPage = (currentPage) => {
  return {
    type: constants.SET_SUBTEMPLATE_TRAINING_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const setTemplateTrainingVideosPageCount = (pageCount) => {
  return {
    type: constants.SET_TEMPLATE_TRAINING_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setTemplateTrainingVideosCurrentPage = (currentPage) => {
  return {
    type: constants.SET_TEMPLATE_TRAINING_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const getTemplateTrainingVideos = (page = 1) => {
  return (dispatch) => {
    API.get(`admin/exercises/preset?page=${page}`)
      .then((resp) => {
        dispatch(setTemplateTrainingVideosCurrentPage(resp.data.meta.current_page));
        dispatch(setTemplateTrainingVideosPageCount(resp.data.meta.last_page));
        dispatch(setTemplateTrainingVideos(resp.data.data));
      })
      .catch(() => {
        toastError('Ошибка получения шаблонов видео тренеровок');
      });
  };
};
export const isSubtemplateTrainingVideosLoading = () => {
  return {
    type: constants.SET_SUBTEMPLATE_TRAINING_VIDEOS_LOADING,
  };
};
export const isSubtemplateTrainingVideosEndLoading = () => {
  return {
    type: constants.SET_SUBTEMPLATE_TRAINING_VIDEOS_END_LOADING,
  };
};

export const getSubtemplateTrainingVideos = (page = 1) => {
  return (dispatch) => {
    dispatch(isSubtemplateTrainingVideosLoading());
    API.get(`admin/exercises/subpattern?page=${page}`)
      .then((resp) => {
        dispatch(setSubtemplateTrainingVideosCurrentPage(resp.data.meta.current_page));
        dispatch(setSubtemplateTrainingVideosPageCount(resp.data.meta.last_page));
        dispatch(setSubtemplateTrainingVideos(resp.data.data));
        dispatch(isSubtemplateTrainingVideosEndLoading());
      })
      .catch(() => {
        dispatch(isSubtemplateTrainingVideosEndLoading());
        toastError('Ошибка получения подшаблонов видео тренеровок');
      });
  };
};

export const setTrainingVideosPageCount = (pageCount) => {
  return {
    type: constants.SET_TRAINING_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setTrainingVideosCurrentPage = (currentPage) => {
  return {
    type: constants.SET_TRAINING_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};
export const isTrainingVideosLoading = () => {
  return {
    type: constants.SET_TRAINING_VIDEOS_LOADING,
  };
};
export const isTrainingVideosEndLoading = () => {
  return {
    type: constants.SET_TRAINING_VIDEOS_END_LOADING,
  };
};

export const setLimberingUpPageCount = (pageCount) => {
  return {
    type: constants.SET_LIMBERING_UP_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setLimberingUpCurrentPage = (currentPage) => {
  return {
    type: constants.SET_LIMBERING_UP_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const setInterruptionPageCount = (pageCount) => {
  return {
    type: constants.SET_INTERRUPTION_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setInterruptionCurrentPage = (currentPage) => {
  return {
    type: constants.SET_INTERRUPTION_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const setSelfDevelopmentPageCount = (pageCount) => {
  return {
    type: constants.SET_SELF_DEVELOPMENT_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setSelfDevelopmentCurrentPage = (currentPage) => {
  return {
    type: constants.SET_SELF_DEVELOPMENT_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const setMotivationPageCount = (pageCount) => {
  return {
    type: constants.SET_MOTIVATION_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setMotivationCurrentPage = (currentPage) => {
  return {
    type: constants.SET_MOTIVATION_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const setWelcomePageCount = (pageCount) => {
  return {
    type: constants.SET_WELCOME_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setWelcomeCurrentPage = (currentPage) => {
  return {
    type: constants.SET_WELCOME_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const setFaqPageCount = (pageCount) => {
  return {
    type: constants.SET_FAQ_VIDEOS_PAGE_COUNT,
    payload: {
      pageCount,
    },
  };
};

export const setFaqCurrentPage = (currentPage) => {
  return {
    type: constants.SET_FAQ_VIDEOS_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const setLoadingDelete = () => {
  return {
    type: constants.SET_LOADING_DELETE,
  };
};
export const setEndLoadingDelete = () => {
  return {
    type: constants.SET_END_LOADING_DELETE,
  };
};
export const openDeleteModal = () => {
  return {
    type: constants.OPEN_DELETE_MODAL,
  };
};
export const closeDeleteModal = () => {
  return {
    type: constants.CLOSE_DELETE_MODAL,
  };
};

export const deleteTemplateTrainingVideos = (productId) => {
  return (dispatch) => {
    dispatch(setLoadingDelete());
    API.delete(`admin/exercises/preset/${productId}`)
      .then(() => {
        dispatch(setEndLoadingDelete());
        dispatch(closeDeleteModal());
        toastSuccess('Шаблон видео успешно удален');
      })
      .catch(() => {
        dispatch(closeDeleteModal());
        dispatch(setEndLoadingDelete());
      });
  };
};

export const deleteSubTemplateTrainingVideos = (productId) => {
  return (dispatch) => {
    dispatch(setLoadingDelete());
    API.delete(`/admin/exercises/subpattern/${productId}`)
      .then(() => {
        dispatch(setEndLoadingDelete());
        dispatch(closeDeleteModal());
        toastSuccess('Подшаблон видео успешно удален');
      })
      .catch(() => {
        dispatch(closeDeleteModal());
        dispatch(setEndLoadingDelete());
      });
  };
};

export const deleteTrainingVideos = (productId) => {
  return (dispatch) => {
    dispatch(setLoadingDelete());
    API.delete(`/admin/exercises/video/${productId}`)
      .then(() => {
        dispatch(setEndLoadingDelete());
        dispatch(closeDeleteModal());
        toastSuccess('Шаблон видео успешно удален');
      })
      .catch(() => {
        dispatch(closeDeleteModal());
        dispatch(setEndLoadingDelete());
      });
  };
};

export const searchTemplateVideosByName = (name, page = 1, tags = []) => {
  return (dispatch) => {
    const queryStrTagsIds = tags.join('|');
    API.get(`admin/exercises/preset?name=${name}&page=${page}&tags=${queryStrTagsIds}`)
      .then((resp) => {
        dispatch(setTemplateTrainingVideosCurrentPage(resp.data.meta.current_page));
        dispatch(setTemplateTrainingVideosPageCount(resp.data.meta.last_page));
        dispatch(setTemplateTrainingVideos(resp.data.data));
      })
      .catch(() => {
        toastError('Ошибка поиска шаблонов');
      });
  };
};

export const searchSubtemplateVideosByName = (name, page = 1, tags = []) => {
  return (dispatch) => {
    const queryStrTagsIds = tags.join('|');
    dispatch(isSubtemplateTrainingVideosLoading());
    API.get(`admin/exercises/subpattern?name=${name}&page=${page}&tags=${queryStrTagsIds}`)
      .then((resp) => {
        dispatch(setSubtemplateTrainingVideosCurrentPage(resp.data.meta.current_page));
        dispatch(setSubtemplateTrainingVideosPageCount(resp.data.meta.last_page));
        dispatch(setSubtemplateTrainingVideos(resp.data.data));
        dispatch(isSubtemplateTrainingVideosEndLoading());
      })
      .catch(() => {
        dispatch(isSubtemplateTrainingVideosEndLoading());
        toastError('Ошибка поиска подшаблона');
      });
  };
};

export const searchVideos = (types, name = '', page = 1, tags = []) => {
  return (dispatch) => {
    const queryStrTagsIds = tags.join('|');
    dispatch(isTrainingVideosLoading());
    API.get(
      `admin/exercises/videos/${DEFAULT_TYPE_OF_VIDEOS_FOR_REQUEST[types]}?name=${name}&page=${page}&tags=${queryStrTagsIds}`,
    )
      .then((resp) => {
        dispatch(isTrainingVideosEndLoading());
        if (types === 'main_video') {
          dispatch(setTrainingVideosCurrentPage(resp.data.current_page));
          dispatch(setTrainingVideosPageCount(resp.data.last_page));
          dispatch(setTrainingVideosList(resp.data.data));
        } else if (types === 'limbering_up') {
          dispatch(setLimberingUpCurrentPage(resp.data.current_page));
          dispatch(setLimberingUpPageCount(resp.data.last_page));
          dispatch(setLimberingUpVideo(resp.data.data));
        } else if (types === 'interruption') {
          dispatch(setInterruptionCurrentPage(resp.data.current_page));
          dispatch(setInterruptionPageCount(resp.data.last_page));
          dispatch(setInterruptionVideo(resp.data.data));
        } else if (types === 'self_development') {
          dispatch(setSelfDevelopmentCurrentPage(resp.data.current_page));
          dispatch(setSelfDevelopmentPageCount(resp.data.last_page));
          dispatch(setSelfDevelopmentVideo(resp.data.data));
        } else if (types === 'motivation') {
          dispatch(setMotivationCurrentPage(resp.data.current_page));
          dispatch(setMotivationPageCount(resp.data.last_page));
          dispatch(setMotivationVideo(resp.data.data));
        } else if (types === 'welcome') {
          dispatch(setWelcomeCurrentPage(resp.data.current_page));
          dispatch(setWelcomePageCount(resp.data.last_page));
          dispatch(setWelcomeVideo(resp.data.data));
        } else if (types === 'faq') {
          dispatch(setFaqCurrentPage(resp.data.current_page));
          dispatch(setFaqPageCount(resp.data.last_page));
          dispatch(setFaqVideo(resp.data.data));
        }
      })
      .catch(() => {
        dispatch(isTrainingVideosEndLoading());
        toastError('Ошибка поиска видео');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/videos/trainingVideos.js